//export const LOGIN = "/sharp/individual/yearSelection";
export const SIGNUP = "/beneficiary-api/beneficiary/signUp";
export const LOGIN = "/beneficiary-api/authenticate";
//export const LOGIN = "/login/LoginBeneAndAgent";
// export const SIGNUP = "/login/BeneficiarySignUp";
export const GUEST_LOGIN = "/beneficiary-api/guestLogin";
export const YEAR_SELECTION = "/sharp/individual/selectedPlans";
export const PLAN_SELECTION_CONTINUE = "/e-enroll-plans-api/selectPlan";
export const SUBMIT_FORM = "/beneficiary-api/enrollment/save";
export const DOWNLOAD_PDF = "/sharp/individual/Download";
export const GET_CLINICAL_NAME = "/sharp/individual/clinicName?ofcCde=";
export const SAVE_LOGOUT = "/beneficiary-api/enrollment/saveAndLogout";
export const FORGOT_LOGIN_DETAIL = "/forgotpassword/sendEmail?emailId=";
export const RESET_LOGIN = "/password/change";
export const DOWNLOAD_FORM = "/beneficiary-api/download/pdf";
export const PDF_UPLOAD = "/sharp/individual/updatePdf";
export const UPLOAD_FILES = "/beneficiary-api/upload/files";
export const DELETE_FILE = "/beneficiary-api/deleteFile";
//------->
export const PLAN_SUMMARY = "/e-enroll-plans-api/getPlanSummary";
export const COMPARE_PLAN = "/e-enroll-plans-api/comparePlans";
export const PLAN_DETAILS = "/e-enroll-plans-api/getPlanDetails";
//export const PLAN_SUMMARY_BY_ID ="/e-enroll-plans-api/getPlanSummary";
export const PLAN_SUMMARY_BY_ID = "/cambia/getPlanSnapshotByIdAndZip";
export const EMAIL_PLAN = "/e-enroll-plans-api/emailPlan";
export const EMAIL_SHARP_PLAN = "/e-enroll-plans-api/saveMyProgress";
//export const STATUS_DASHBOARD ="/cambia/getApplDetails";
export const STATUS_DASHBOARD =
  "/beneficiary-api/beneficiary/submitted/applicationStatus";
export const CATEGORY_DASHBOARD =
  "/beneficiary-api/beneficiary/applicationStatus";
export const CHECKELIGIBILITY = "/beneficiary-api/eligibilityCheck";
export const SEARCH_EXISTING_APP =
  "/beneficiary-api/beneficiary/searchExisting";
export const SET_ENROLLMENT_REDIRECT = "/beneficiary-api/loadApplication";
export const GET_PCPS = "/beneficiary-api/getNearestPcpDetails";
//export const GET_ZIPCODES = "/cambia/getStateCountyByZipCode/"
export const GET_ZIPCODES =
  "/beneficiary-api/beneficiary/getCountyByZipCode?zipCode=";
export const GET_LATEST_APPLICATION =
  "/beneficiary-api/beneficiary/getLatestApplication";
export const GET_CAMPAIGN_LIST = "/e-enroll-agent-api/campaign/search";
export const SAVE_ENROLL="/e-enroll-agent-api/campaign/saveOrUpdate";
export const SAVE_CAMPAIGN_OWNER="/e-enroll-agent-api/campaignOwner/saveOrUpdate";
export const SAVE_SOA="/e-enroll-agent-api/soa/save";
export const GET_AGENT_LIST="/e-enroll-agent-api/agentList";
export const GET_LTC_LIST="/beneficiary-api/ltcList";
export const SEARCH_PROSPECT="/e-enroll-agent-api/prospect/search";
export const GET_CITY_LIST="beneficiary-api/city/Search"
export const SAVE_DEMOGRAPHICS="/e-enroll-agent-api/prospectDemographics/saveOrUpdate";
export const SAVE_PROSPECT="/e-enroll-agent-api/prospect/saveOrUpdate";
export const GET_CALLS_DATA="/e-enroll-agent-api/searchCall";
export const GET_COMMENTS_DATA="/e-enroll-agent-api/loadComments";
export const ADD_NEW_COMMENT="/e-enroll-agent-api/addComments";
export const SAVE_CALLS="/e-enroll-agent-api/saveCall";
export const DOWNLOAD_SOA_PDF="/e-enroll-agent-api/soa/pdf/download";
export const LOAD_DEMOGRAPHICS="/e-enroll-agent-api/prospectDemographics/load";
export const LOAD_SOA="/e-enroll-agent-api/soa/load";
export const GET_AGENCY_ID="/e-enroll-agent-api/agencyId?agentId=";
export const LOAD_PROSPECT="/e-enroll-agent-api/prospect/load";
export const GET_AGENT_IN_FORM="/e-enroll-agent-api/agentList?customerId=";
export const MEMBERSHIP_AGENT_lIST="/e-enroll-agent-api/agentIdList?customerId=";
export const GET_STATES="beneficiary-api/states/list";
export const GET_CALLS_DATA_ROWSELECT="/e-enroll-agent-api/loadCall";
export const KEY_PERFORMANCE_BY_AGENT="/e-enroll-agent-api/agent/keyPerformance";
export const  KEY_PERFORMANCE_BY_CAMPAIGN="/e-enroll-agent-api/campaign/performance";
export const PCP_MAP_POPUP = "/appl/pcpList";
export const PCP_POPUP = "/appl/pcpSearch";
export const DIGITAL_SIGN="/beneficiary-api/upload/signature";
export const EXPORT_PERFORMANCE_BY_AGENT="/e-enroll-agent-api/agent/performance/export";
export const EXPORT_PERFORMANCE_BY_CAMPAIGN="/e-enroll-agent-api/campaign/performance/export";
export const GET_CAMPAIGN_NAMES="/e-enroll-agent-api/getCampaignList";
export const GET_CAMPAIGN_OWNER_NAMES="/e-enroll-agent-api/getCampaignOwnerList";
export const FORGET_EMAIL="/beneficiary-api/forgotpassword/sendEmail";
export const NEW_VALUES_FOR_LOGIN="/beneficiary-api/password/change";
export const PIE_CHART_FILTER="/beneficiary-api/beneficiary/submitted/applicationStatusByDates";
export const PENDING_APP_LIST="/beneficiary-api/application/list";
export const GET_CUSTOMER_SUBDOMAIN="/beneficiary-api/init";
export const GET_AUTH_RELATIONS="e-enroll-plans-api/authRelations";
export const DOWNLOAD_FORMS_PDF="/beneficiary-api/download/pdf";
export const ASSIGN_PROSPECT="/e-enroll-agent-api/prospect/assign";
export const LOAD_EVENTS="/e-enroll-agent-api/calendarEvent/load";
export const SAVE_EVENTS="/e-enroll-agent-api/calendarEvent/save";
export const PROSPECT_FILE_UPLOAD="/e-enroll-agent-api/bulkUpload/prospect";
export const CAMPAIGN_FILE_UPLOAD="/e-enroll-agent-api/bulkUpload/campaign";
export const GET_PROSPECT_FILES_DATA="/e-enroll-agent-api/prospect/upload/file/status";
export const GET_CAMPAIGN_FILES_DATA="/e-enroll-agent-api/campaign/upload/file/status";
export const LOAD_CAMPAIGN_FILEDATA="e-enroll-agent-api/campaign/upload/file/details";
export const LOAD_PROSPECT_FILEDATA="e-enroll-agent-api/prospect/upload/file/details";
export const UPDATE_PROSPECT_RECORDS="e-enroll-agent-api/prospect/update/file/details";
export const UPDATE_CAMPAIGN_RECORDS="e-enroll-agent-api/campaign/update/file/details";
export const GET_SEP_REASONS="/e-enroll-plans-api/sepReasons";
export const RAPID_DISENROLLMENT_BYMONTH="/e-enroll-agent-api/application/disenrollment";
export const MBI_DETAILS="/beneficiary-api/mbiDetails";
export const VERDA_CARE_ENROLL_PDF="/beneficiary-api/getOtherPdf";
export const KEYCLOAK_TOKEN="/auth-api/token";
export const KEYCLOAK_LOGOUT="/auth-api/logout";
export const FETCH_KEYCLOAK_USERID="/beneficiary-api/getUserId";
export const FETCH_APPOINTMENTS="/e-enroll-agent-api/appointment/details";
export const LOADPROSPECTONAGENT="/e-enroll-agent-api/agent/prospectList";
export const GET_USER_MANAGEMENT_DATA="/e-enroll-agent-api/getAllUsers";
export const GET_USER_ROLE_CHANGE="/e-enroll-agent-api/changeRole";
// export const GET_USER_ROLE_CHANGE1="/e-enroll-agent-api/bulkChangeRole"
export const GET_FILE_ATTACHMENT_TYPES="/beneficiary-api/getAttachmentTypes";